import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {GotchaMainResponseVo} from '../../common/shared/api/nicolas/vo/GotchaMainResponseVo.interface';
import type {Maybe} from '../../graphql/generated/types';

export type GetGotchaWebParams = {
  gotchaId: string;
  adLocId?: Maybe<string>;
};

/**
 * 갓챠 정보 조회 (v3, web용)
 *
 * Origin: pageNicolasApi.getGotchaWeb
 * API: POST /api/v3/gotcha
 */
export async function postGotchaGetWeb(
  {gotchaId, adLocId}: GetGotchaWebParams,
  options?: FetcherOptions
): Promise<
  ApiResultVo & {
    gotcha_id: string;
    gotcha_info: GotchaMainResponseVo;
  }
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v3/gotcha',
    {
      method: 'POST',
      data: {
        map_uid: gotchaId,
        ...(adLocId && {ad_loc_id: adLocId}),
      },
    },
    options
  );
  return response.data;
}
